import React from 'react';
import {
  Carousel as ReactResponsiveCarousel,
  CarouselProps as ReactResponsiveCarouselProps,
 } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';


interface CarouselProps {
  children: React.ReactChild[];
  settings: Partial<ReactResponsiveCarouselProps>;
};

function Carousel ({ children, settings }: CarouselProps) {
  return (
    <ReactResponsiveCarousel {...settings}>
      {children}
    </ReactResponsiveCarousel>
  );
};


export default Carousel;
